
import FeedIcon from "@mui/icons-material/Feed";
import { Box, Typography, CircularProgress, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { fetchAktualityConfig } from "../services/aktualityService";
import axiosInstance from "../services/axiosInstance";

export default function AktualityPage() {
  const [aktualita, setAktualita] = useState("");
  const [aktualitaPdf, setAktualitaPdf] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const getAktualita = async () => {
      setError("");
      setLoading(true);
      const result = await fetchAktualityConfig();
      if (result.success) {
        setAktualita(result.data.aktualita || "");
        setAktualitaPdf(result.data.aktualita_pdf || null);
      } else {
        setError("Nepodařilo se načíst aktualitu.");
      }
      setLoading(false);
    };
    getAktualita();
  }, []);

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", p: 2 }}>
        <CircularProgress />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Načítání aktuality...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: "center", p: 2 }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  // Pokud není žádná aktualita ani PDF, nezobrazuj nic
  if (!aktualita && !aktualitaPdf) {
    return null;
  }

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Aktuality
      </Typography>
      <FeedIcon color="primary" />
      {aktualita && (
        <Typography variant="body1" sx={{ mt: 2 }}>
          {aktualita}
        </Typography>
      )}
      {aktualitaPdf && (
        <Box sx={{ mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={async () => {
              try {
                const response = await axiosInstance.get("/api/config/aktualita", {
                  responseType: "blob",
                });
                const pdfBlob = new Blob([response.data], { type: "application/pdf" });
                const pdfUrl = URL.createObjectURL(pdfBlob);
                window.open(pdfUrl, "_blank");
              } catch (error) {
                alert("Chyba při stahování PDF.");
              }
            }}
          >
            Stáhnout PDF k aktualitě
          </Button>
        </Box>
      )}
    </Box>
  );
}
